var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 77,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M13.5575 64.1666C11.7929 64.1666 10.2823 63.5383 9.0257 62.2817C7.7691 61.0251 7.1408 59.5145 7.1408 57.7499V19.2499C7.1408 17.4853 7.7691 15.9747 9.0257 14.7181C10.2823 13.4616 11.7929 12.8333 13.5575 12.8333H64.8908C66.6554 12.8333 68.166 13.4616 69.4226 14.7181C70.6792 15.9747 71.3075 17.4853 71.3075 19.2499V57.7499C71.3075 59.5145 70.6792 61.0251 69.4226 62.2817C68.166 63.5383 66.6554 64.1666 64.8908 64.1666H13.5575ZM39.2241 41.7083L13.5575 25.6666V57.7499H64.8908V25.6666L39.2241 41.7083ZM39.2241 35.2916L64.8908 19.2499H13.5575L39.2241 35.2916ZM13.5575 25.6666V19.2499V57.7499V25.6666Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.a20617e736b3f1a779da3f199c55c665.svg";
export { ForwardRef as ReactComponent };